import React from 'react';
import EmploymentFormContainer from '../../containers/EmploymentFormContainer';
import ProgressBar2 from '../ProgressBar2';
import EmploymentProfessionalModal from './EmploymentProfessionalModal';

const EmploymentPage = () => {
  return (
    <section className="form-content-section-primary flow-text">
      <ProgressBar2 />
      <div className="container">
        <div className="row">
          <div id="appEmployment" className="col col-md-12 col-lg-8 col-lg-offset-2 no-side-padding">
            <EmploymentFormContainer />
          </div>
        </div>
      </div>
      <EmploymentProfessionalModal />
    </section>
  );
};

export default EmploymentPage;
